import { type ReactNode } from 'react';
import { useRed } from './useRed.js';
import { alternarRed } from '../almacen/red.js';

/** Marco de teléfono que envuelve la app del médico (estética de los mockups). */
export function MarcoTelefono({ children }: { children: ReactNode }) {
  const online = useRed();
  const hora = new Date().toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
  return (
    <div className="escena">
      <div className="telefono">
        <div className="barra-sistema">
          <span>{hora}</span>
          <span className="iconos">
            <span>{online ? '📶' : '✕📶'}</span>
            <span
              title="Alternar conexión (demo del modo contingencia)"
              style={{ cursor: 'pointer' }}
              onClick={() => alternarRed()}
            >
              {online ? '🛜' : '🚫'}
            </span>
            <span>🔋</span>
          </span>
        </div>
        {!online && (
          <div className="banda-offline">
            <span>⚠️</span> Sin conexión — modo contingencia activo
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
